module.exports = __webpack_public_path__ + "static/media/cross.d5209bce.svg";